import React, {useEffect, useState} from 'react'
import {makeStyles} from "@material-ui/styles";
import DemandValidationMessages from "components/DemandValidationMessages";
import Button from "components/Button";
import Tr from "translations/Translations";
import GridBlock from "components/GridBlock";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import {useParams} from "react-router";
import RouterPath from "libs/RouterPath";
import {confirmComplex} from "libs/ConfirmNotification";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import {PurchasingGroupStageSections} from "../../../constants/PurchasingGroupStageSections";

const useStyle = makeStyles(theme => ({
    root: {
        width: "100%"
    }
}))

function PurchasingGroupStage1FinishPreparing(
    {
        panelRef,
        validationSection
    }) {
    const classes = useStyle();
    const params = useParams();
    const groupId = params.id;
    const editable = validationSection.editable;

    const [canFinish, setCanFinish] = useState(false)

    useEffect(() => {
        PurchasingGroupSectionService.getSections(groupId, PurchasingGroupStageSections.FINISH_PREPARING)
        PurchasingGroupStage1Service.canFinishPreparing(groupId).then(resp => {
            if (resp) {
                setCanFinish(resp.result);
            } else {
                setCanFinish(false);
            }
        });
    }, [groupId]);

    const finishPreparingState = () => {
        PurchasingGroupStage1Service.finishPreparingStage(groupId).then(resp => {
            if (resp) {
                PurchasingGroupStage1Service.getHeader(groupId);
                const path = RouterPath.createPath(RouterPath.purchasingGroup.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR, {id: groupId, stage: 2});
                RouterPath.redirect(path);
            } else {
            }
        });
    }

    return (<div className={classes.root}>
        <DemandValidationMessages editable={validationSection.editable} section={validationSection}/>
        <GridBlock
            direction='column'
            alignItems='center'
        >
            <Button
                disabled={!editable || !canFinish}
                onClick={() => confirmComplex({
                    onConfirm: () => finishPreparingState(),
                    confirmText: Tr('purchasing_group_finish_preparing_confirm1'),
                    confirmText2: Tr('purchasing_group_finish_preparing_confirm2'),
                    translateConfirmTexts: false
                })}
            >
                {Tr('purchasing_group_finish_preparing_action')}
            </Button>
        </GridBlock>
    </div>)
}

PurchasingGroupStage1FinishPreparing.propTypes = {}

export default PurchasingGroupStage1FinishPreparing;